import moment from '../../../node_modules/moment'
import {SERVER_DATE_FORMAT} from './formatter'

export const compareDataOra = function (dt1, dt2) {
  return dt1.date[0] === dt2.date[0] && dt1.date[1] === dt2.date[1] && dt1.date[2] === dt2.date[2] && dt1.time[0] === dt2.time[0] && dt1.time[1] === dt2.time[1]
}

export const dateBetween = function (date, from, to) {
  return date.getTime() >= from.getTime() && date.getTime() <= to.getTime()
}

export const daysBetweenDates = function (dt1, dt2) {
  const dd1 = moment(dt1)
  const dd2 = moment(dt2)
  return dd2.diff(dd1, 'days')
}

export const daysBetweenDatesString = function (dt1, dt2, frmt) {
  const dd1 = moment(dt1, frmt)
  const dd2 = moment(dt2, frmt)
  return dd2.diff(dd1, 'days')
}

export const isInInterval = function (date, from, to) {
  const middleDate = moment(date).startOf('day')
  const fromDate = moment(from).startOf('day')
  const toDate = moment(to).startOf('day')
  return middleDate.isSame(fromDate) || middleDate.isSame(toDate) || (middleDate.isAfter(fromDate) && middleDate.isBefore(toDate))
}

export const daysBetweenPeriod = function (period) {
  return daysBetweenDates(period.start, period.end)
}

export const isDateInPeriod = function (date, period) {
  const middleDate = moment(date).startOf('day')
  const fromDate = moment(period.start).startOf('day')
  const toDate = moment(period.end).startOf('day')
  return middleDate.isSame(fromDate) || middleDate.isSame(toDate) || (middleDate.isAfter(fromDate) && middleDate.isBefore(toDate))
}

export const isSamePeriod = function (p1, p2) {
  return p1.start.getTime() === p2.start.getTime() && p1.end.getTime() === p2.end.getTime()
}
export const isSameDate = function (d1, d2) {
  const date1 = moment(d1).format(SERVER_DATE_FORMAT)
  const date2 = moment(d2).format(SERVER_DATE_FORMAT)
  return date1 === date2
}

export const clone = function (obj) {
  return convertDates(JSON.parse(JSON.stringify(obj)))
}

export const convertDates = (obj) => {
  for (const property in obj) {
    if (obj.hasOwnProperty(property)) {
      if (obj[property] instanceof Object || obj[property] instanceof Array) {
        convertDates(obj[property])
      } else {
        if (typeof obj[property] === 'string' && isIsoDate(obj[property])) {
          obj[property] = new Date(obj[property])
        }
      }
    }
  }
  return obj
}

export function isIsoDate (str) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false
  const d = new Date(str)
  return d.toISOString() === str
}

export const isFullTimeOrario = function (orario) {
  return orario[0].h === 0 && orario[0].m === 0 && orario[1].h === 24 && orario[1].m === 0
}

export const isContentInOrario = function (range, orario) {
  const minuteRange = [range[0].h * 60 + range[0].m, range[1].h * 60 + range[1].m]
  const minuteOrario = [orario[0].h * 60 + orario[0].m, orario[1].h * 60 + orario[1].m]
  return minuteRange[0] <= minuteOrario[0] && minuteRange[1] >= minuteOrario[1]
}

export const airportName = function (name) {
  return name.toLowerCase().replace('aeroporto internazionale di', '').replace('aeroporto internazionale', '').replace('aeroporto di', '')
}

export const hotelName = function (name) {
  const name2 = name.split('<')[0]
  return name2.replace('- All Inclusive', '').replace('All Inclusive', '')
}

export const roomHotelName = function (name) {
  return name.split('(')[0].toUpperCase()
}

export const tourName = function (name) {
  const arr = name.split('"')
  return arr.length > 2 ? arr[1] : arr[0]
}

export const countPersons = function (camere) {
  return countAdults(camere) + countChilds(camere)
}

export const countAdults = function (camere) {
  if (!camere) return 0
  let adults = 0
  for (let i = 0; i < camere.length; i++) {
    adults += camere[i].adults
  }
  return adults
}

export const countChilds = function (camere) {
  if (!camere) return 0
  let childs = 0
  for (let i = 0; i < camere.length; i++) {
    childs += camere[i].childs.length
  }
  return childs
}

export const camereText = function (camere) {
  let text = ''
  const adults = countAdults(camere)
  const childs = countChilds(camere)
  if (camere && camere.length > 0) {
    text += camere.length + (camere.length === 1 ? ' camera: ' : ' camere: ')
    text += adults + (adults === 1 ? ' adulto' : ' adulti')
    if (childs > 0) {
      text += ', ' + childs + (childs === 1 ? ' bambino' : ' bambini')
    }
  }
  return text
}

export const cameraText = function (camera) {
  if (!camera) return ''
  const {adults, childs} = camera
  let text = ''
  text += adults + (adults === 1 ? ' adulto' : ' adulti')
  if (childs && childs.length > 0) {
    text += ', ' + childs.length + (childs.length === 1 ? ' bambino' : ' bambini')
  }
  return text
}

export const emailIsValid = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

export const toBrTag = (str) => {
  return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
}



// WEBPACK FOOTER //
// ./src/front/utils/helper.js